/**
 * @author: lv.chen
 * @date: 2025/4/27
 * @desc: SelectButton按钮组件
 */
import React from 'react';
import classnames from 'classnames';
import { Icon, Input } from 'tea-component';
import GeneralDeletableTagList from '@gp/components/GeneralDeletableTagList';

import type { IBaseProps } from '@home/types/common';
import type { IGeneralTagFormatter } from '@gp/components/GeneralTag';

import './index.scss';

interface ISelectButtonProps extends IBaseProps {
  placeholder?: string;
  formatter?: IGeneralTagFormatter;
  tags?: string[] | null;
  onDelete?: (text?: string) => void;
  searchValue?: string;
  onSearch?: (keyword: string) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const SelectButton: React.FC<ISelectButtonProps> = (props) => {
  const { style, className, placeholder, formatter, tags, onDelete, searchValue, onSearch, onClick } = props;
  const hasTags = Array.isArray(tags) && !!tags.length;

  return (
    <div
      style={style}
      className={classnames('dbg-customize-tag-select-button', className, { 'has-padding-top': hasTags })}
      onClick={onClick}
    >
      <div className="dbg-customize-tag-select-button__value-box">
        <GeneralDeletableTagList tags={tags} formatter={formatter} onDelete={onDelete} />
      </div>
      <div className="dbg-customize-tag-select-button__footer">
        <Input
          className="dbg-customize-tag-select-button__input"
          placeholder={placeholder}
          value={searchValue}
          onChange={(payload) => {
            onSearch?.(payload || '');
          }}
        />
        {!!searchValue && (
          <Icon
            className="dbg-customize-tag-select-button__delete-btn"
            type="dismiss"
            onClick={(e) => {
              e?.stopPropagation();
              onSearch?.('');
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SelectButton;
